import { useState } from 'react';
import { ModalTemplate } from '../components/ModalTemplate';
import { DialogBaseProps } from '../types';
import { handleOnConfirmAsync } from '../utils/handleOnConfirmAsync';
import { modal } from '../utils/modal';

export type PromptConfig = Omit<
  DialogBaseProps<string>,
  | 'showRememberActionCheckbox'
  | 'rememberActionCustomCheckboxText'
  | 'onConfirmAsync'
> & {
  inputLabel?: string;
  initialInputValue?: string;
  cancelButtonTitle?: string;
  cancelButtonClickId?: string;
  textInputId?: string;
  inputPlaceHolderText?: string;
};

/**
 * @deprecated Avoid this in new code. Use `AnimatedModal` and control `isOpen`
 * like any other state. See #19797
 */
export const prompt = ({
  title,
  errorMessage,
  body,
  confirmButtonTitle = 'Ok',
  confirmButtonClickId,
  cancelButtonTitle = 'Cancel',
  cancelButtonClickId,
  isConfirmButtonDanger,
  initialInputValue,
  shouldCloseOnBackdropClick,
  shouldCloseOnEscapeKey,
  errorAlertTitle,
  errorAlertSubtitle,
  ...restOfDialogBaseProps
}: PromptConfig) => {
  return modal<string>(
    resolve => {
      const [inputValue, setInputValue] = useState<string>(
        initialInputValue || ''
      );
      const onConfirm = inputValue
        ? () =>
            handleOnConfirmAsync({
              resolve,
              errorAlertTitle,
              errorAlertSubtitle,
            })(inputValue)
        : undefined;

      return (
        <ModalTemplate
          headerText={title}
          inputValue={inputValue}
          onInputValueChange={setInputValue}
          errorBlockMessage={errorMessage}
          primaryButtonText={!isConfirmButtonDanger ? confirmButtonTitle : ''}
          primaryButtonClickId={confirmButtonClickId}
          onPrimaryButtonClick={onConfirm}
          isPrimaryButtonDisabled={!inputValue}
          dangerButtonText={isConfirmButtonDanger ? confirmButtonTitle : ''}
          dangerButtonClickId={confirmButtonClickId}
          onDangerButtonClick={onConfirm}
          onInputEnterPress={onConfirm}
          isDangerButtonDisabled={!inputValue}
          secondaryButtonText={cancelButtonTitle}
          secondaryButtonClickId={cancelButtonClickId}
          onSecondaryButtonClick={() => resolve(false)}
          {...restOfDialogBaseProps}
        >
          {body}
        </ModalTemplate>
      );
    },
    { shouldCloseOnBackdropClick, shouldCloseOnEscapeKey }
  );
};
